module.exports = "<div class=\"q-alert q-alert-grey q-no-pad q-marg-vert-xl\"> <p class=q-marg-all-sm> Estimated shipping cost cannot be provided. Please submit shipping information and contact your CSS to get your shipping estimate and BOL number. </p> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/amazon-fba-order/html/quoteResponseFailure.html
// module id = 1200
// module chunks = 1